module.exports = __webpack_public_path__ + "static/media/turkish-people2.674906b8.svg";